import { render, staticRenderFns } from "./CreateTaxPph23Code.vue?vue&type=template&id=d506aa5e"
import script from "./CreateTaxPph23Code.vue?vue&type=script&lang=js"
export * from "./CreateTaxPph23Code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports